import { Box, Typography } from '@mui/material';
import type { PortableTextMarkComponentProps, PortableTextReactComponents } from '@portabletext/react';
import { PortableText } from '@portabletext/react';
import type { FC } from 'react';
import { Link } from '~/components/atoms/Link';
import { getCompoundTestIdGenerator } from '~/utils/getCompoundTestIdGenerator';
import { isPortableTextBlockArray } from '~/utils/portableTextUtils';
import type { LoyaltyAboutRichTextProps } from './LoyaltyAboutRichText.types';

const createRichTextComponents: () => Partial<PortableTextReactComponents> = () => ({
  block: {
    heading: ({ children }) => (
      <Typography variant="subtitle2" component="h2" sx={{ my: 4 }}>
        {children}
      </Typography>
    ),
    normal: ({ children }) => (
      <Typography variant="body2" component="p" sx={{ my: 2 }}>
        {children}
      </Typography>
    ),
  },
  marks: {
    link: ({ value, children }: PortableTextMarkComponentProps<{ _type: string; _key: string; href: string }>) => {
      if (!value || !value.href) {
        return <span>{children}</span>;
      }

      return (
        <Link to={value.href} id={`loyaltyAboutRichText_link_${value._key}`}>
          {children}
        </Link>
      );
    },
  },
});

export const LoyaltyAboutRichText: FC<LoyaltyAboutRichTextProps> = ({ loyaltyAboutRichTextContent: content }) => {
  const richTextComponents = createRichTextComponents();

  if (!content) {
    return null;
  }

  const compoundTestIdGenerator = getCompoundTestIdGenerator('loyaltyAboutRichText');

  return (
    <Box
      sx={{
        textAlign: 'center',
        '& > *:first-of-type': { mt: 0 },
        '& > *:last-of-type': { mb: 0 },
      }}
      data-testid={compoundTestIdGenerator()}
    >
      {isPortableTextBlockArray(content) && <PortableText value={content} components={richTextComponents} />}
    </Box>
  );
};
